import templateUrl from './onboarding-comments.html'

export const OnboardingCommentsComponent = {
    templateUrl,
    controller: OnboardingCommentsController,
    controllerAs: "vm",
    bindings: {
        resolve: '<',
        close: "&",
        dismiss: "&"
    }
}

function OnboardingCommentsController($q, $uibModal, $state, $scope, utilityService, employeeService, permissionGrantService, localeService, onboardingDocumentService, employmentRecordEditContextFactory,
    icdOfficeService, payrollService, wagePolicyService) {
    'ngInject'
    const vm = this;
    vm.onSubmit = onSubmit;
    vm.onClose = onClose;
    vm.allComments = {};
    vm.$onInit = function () {
        console.log(vm.resolve);
        vm.allComments = vm.resolve.allComments;
        utilityService.hideLoading();
    }

    function onSubmit() {
        utilityService.showLoading();
        return onboardingDocumentService.saveComment({
            ApplicationId: vm.resolve.appId,
            UserName: vm.resolve.userName,
            Text: vm.commentText
        }).then(function (isSaved) {
            if (isSaved) {
                onboardingDocumentService.retrieveComments(vm.resolve.appId)
                    .then(function (comments) {
                        vm.commentText = '';
                        vm.allComments = comments;
                        utilityService.hideLoading();
                    })
            } else {
                utilityService.hideLoading();
                alert("Saving Comment failed");
            }
            return isSaved;
        }).catch((err) => {
            utilityService.hideLoading();
            alert("Saving Comment failed: " + utilityService.getExceptionMessage(err));
        })
    }

    function onClose() {

    }

}


export const CommentsModal = {
    component: "apexCommentsModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'xs',
    backdrop: 'static'
}
